const TAG_REGEX = /<[^<>\n]+>/g;

export const QUESTIONS_TAG = '<Questions>';

export const extractPromptTags = (promptText) => {
  const text = typeof promptText === 'string' ? promptText : '';
  if (!text.trim()) return [];

  const tags = [];
  const seenTags = new Set();
  let match;
  const regex = new RegExp(TAG_REGEX.source, 'g');

  while ((match = regex.exec(text)) !== null) {
    const tag = String(match[0] || '').trim();
    if (!tag) continue;
    const normalizedTag = tag.toLowerCase();
    if (seenTags.has(normalizedTag)) continue;

    seenTags.add(normalizedTag);
    tags.push(tag);
  }

  return tags;
};

export const buildQuestionTagReference = (tag = QUESTIONS_TAG) => ({
  tag,
  description: 'add questions'
});

export const buildExtraPromptTagReferences = ({ promptText, analysisLabel }) => {
  const sourceLabel = String(analysisLabel || '').trim() || 'Extra Analysis';
  return extractPromptTags(promptText).map((tag) => ({
    tag,
    description: `add ${tag} block from "${sourceLabel}" prompt`
  }));
};

export const dedupeTagReferences = (...groups) => {
  const deduped = [];
  const seen = new Set();

  groups
    .flat()
    .filter(Boolean)
    .forEach((item) => {
      const tag = String(item?.tag || '').trim();
      const description = String(item?.description || '').trim();
      if (!tag || !description) return;

      const key = `${tag.toLowerCase()}::${description.toLowerCase()}`;
      if (seen.has(key)) return;

      seen.add(key);
      deduped.push({ tag, description });
    });

  return deduped;
};

export const tagReferencesToKnownTags = (references) => (
  dedupeTagReferences(references).map((item) => item.tag)
);

const normalizeTagBaseName = (tag) => {
  const body = String(tag || '').trim().replace(/^</, '').replace(/>$/, '');
  if (!body) return '';
  return body.replace(/_[0-9]+$/i, '').toLowerCase();
};

const hasNumericSuffix = (tag) => {
  const body = String(tag || '').trim().replace(/^</, '').replace(/>$/, '');
  return /_[0-9]+$/i.test(body);
};

export const getMismatchedExtraPromptTagWarning = (promptText) => {
  const tags = extractPromptTags(promptText);
  if (tags.length < 2) return '';

  const distinctBaseNames = new Set(
    tags
      .map((tag) => normalizeTagBaseName(tag))
      .filter(Boolean)
  );
  const hasMixedBaseNames = distinctBaseNames.size > 1;
  const hasNonNumericVariant = tags.some((tag) => !hasNumericSuffix(tag));
  if (!hasMixedBaseNames && !hasNonNumericVariant) return '';

  return 'Tags in this extra prompt should share the same base name and differ only by number (example: <Sentiment_1>, <Sentiment_2>).';
};
